import { FaGoogle } from "react-icons/fa";
import "./Login.css";
import bgVideo from "../../assets/lighthouse.mp4";
const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const handleLogin = () => {
    window.location.href = `${API_URL}/auth/google`;
  };

  return (
    <div className="login__container">
      <video src={bgVideo} autoPlay loop muted className="login__video"></video>
      <div className="login__card">
        <h1 className="login__title">Welcome to CrowsNest</h1>
        <p className="login__description">
          Secure access to your personalized search engine. Continue with Google
          for seamless authentication.
        </p>
        <button className="login__google-btn" onClick={handleLogin}>
          <FaGoogle className="login__google-icon" />
          <span>Continue with Google</span>
        </button>
      </div>
    </div>
  );
};

export default Login;
